/**
 * 288 Collapsible Content Section
 * Handles accordion-style collapsible content with smooth animations
 * Converted from jQuery to vanilla JavaScript for better performance
 */

(() => {
  'use strict';

  /**
   * Initialize collapsible content functionality
   */
  const initCollapsibleContent288 = () => {
    const toggles = document.querySelectorAll('.collapsible-content-288__toggle');
    const items = document.querySelectorAll('.collapsible-content-288__item');

    // Set up toggle click handlers
    toggles.forEach(toggle => {
      // Remove existing listeners to prevent duplicates
      const newToggle = toggle.cloneNode(true);
      toggle.parentNode.replaceChild(newToggle, toggle);

      newToggle.addEventListener('click', (e) => handleToggleClick(e, newToggle));
    });

    // Set up hover effects for items
    items.forEach(item => {
      item.addEventListener('mouseenter', () => handleItemHover(item));
      item.addEventListener('mouseleave', () => handleItemLeave(item));
    });
  };

  /**
   * Handle toggle click
   */
  const handleToggleClick = (e, toggle) => {
    const parent = toggle.parentElement;
    const answer = toggle.nextElementSibling;
    const wasActive = parent.classList.contains('active');

    if (!wasActive) {
      // Close all other open items
      const container = toggle.closest('.collapsible-content-288__items');
      if (container) {
        const siblings = Array.from(container.children).filter(
          child => child !== parent && child.classList.contains('collapsible-content-288__item')
        );

        siblings.forEach(sibling => {
          sibling.classList.remove('active');
          const siblingAnswer = sibling.querySelector('.collapsible-content-288__answer');
          if (siblingAnswer) {
            slideUp(siblingAnswer, 300);
          }
        });
      }

      // Open clicked item
      parent.classList.add('active');
      if (answer) {
        slideDown(answer, 300);
      }
    } else {
      // Close clicked item
      parent.classList.remove('active');
      if (answer) {
        slideUp(answer, 300);
      }
    }
  };

  /**
   * Handle item hover
   */
  const handleItemHover = (item) => {
    item.classList.remove('collapsible-content-288__item--opacity');
    
    const siblings = Array.from(item.parentElement.children).filter(
      child => child !== item && child.classList.contains('collapsible-content-288__item')
    );
    
    siblings.forEach(sibling => {
      sibling.classList.add('collapsible-content-288__item--opacity');
    });
  };

  /**
   * Handle item leave
   */
  const handleItemLeave = (item) => {
    const siblings = Array.from(item.parentElement.children).filter(
      child => child.classList.contains('collapsible-content-288__item')
    );
    
    siblings.forEach(sibling => {
      sibling.classList.remove('collapsible-content-288__item--opacity');
    });
  };

  /**
   * Slide down animation (jQuery slideDown equivalent)
   */
  const slideDown = (element, duration = 300) => {
    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;
    if (display === 'none') display = 'block';
    element.style.display = display;

    const height = element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = '0';
    element.style.paddingTop = '0';
    element.style.paddingBottom = '0';
    element.style.marginTop = '0';
    element.style.marginBottom = '0';
    element.offsetHeight; // Force reflow

    element.style.boxSizing = 'border-box';
    element.style.transitionProperty = 'height, margin, padding';
    element.style.transitionDuration = `${duration}ms`;
    element.style.height = `${height}px`;
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');

    setTimeout(() => {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition-duration');
      element.style.removeProperty('transition-property');
    }, duration);
  };

  /**
   * Slide up animation (jQuery slideUp equivalent)
   */
  const slideUp = (element, duration = 300) => {
    element.style.transitionProperty = 'height, margin, padding';
    element.style.transitionDuration = `${duration}ms`;
    element.style.boxSizing = 'border-box';
    element.style.height = `${element.offsetHeight}px`;
    element.offsetHeight; // Force reflow

    element.style.overflow = 'hidden';
    element.style.height = '0';
    element.style.paddingTop = '0';
    element.style.paddingBottom = '0';
    element.style.marginTop = '0';
    element.style.marginBottom = '0';

    setTimeout(() => {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('margin-top');
      element.style.removeProperty('margin-bottom');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition-duration');
      element.style.removeProperty('transition-property');
    }, duration);
  };

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollapsibleContent288);
  } else {
    initCollapsibleContent288();
  }

  // Re-initialize when section is loaded in theme editor
  document.addEventListener('shopify:section:load', initCollapsibleContent288);
})();
